// from we use this to filter the api data according to status
//==============================
export const FilterApiData = (apiData) => {
    if (apiData && apiData.length > 0) {
        let data = apiData.filter((element) => element.status == true)
        return data
    }
    return []
}
